type RiskAnalysisRole = 'risk_executive';
type BoardMemberRole = 'board_member';

type SuperAdminRole = 'super_admin';

type AdminRole = 'admin';

type ManagerRole = 'manager';
type ExecutiveSupervisorRole = 'executive_supervisor';
type SalesAssistantRole = 'sales_assistant';
type SalesExecutiveRole = 'sales_executive';
type CollectionSupervisorRole = 'collection_supervisor';
type CollectionExecutiveRole = 'collection_executive';
type OperationsSupervisorRole = 'operations_supervisor';
type OperationsExecutiveRole = 'operations_executive';
type FinanceSupervisorRole = 'finance_supervisor';
type FinanceExecutiveRole = 'finance_executive';
type TreasuryExecutiveRole = 'treasury_executive';
type ClientRole = 'client';
type GuestRole = 'guest';
type NewUserRole = 'new_user';
type TestRole = 'test';

const RISK_ANALYSIS_ROLE: RiskAnalysisRole = 'risk_executive';
const SUPER_ADMIN_ROLE: SuperAdminRole = 'super_admin';
const ADMIN_ROLE: AdminRole = 'admin';
const MANAGER_ROLE: ManagerRole = 'manager';
const EXECUTIVE_SUPERVISOR_ROLE: ExecutiveSupervisorRole =
  'executive_supervisor';
const SALES_ASSISTANT_ROLE: SalesAssistantRole = 'sales_assistant';
const SALES_EXECUTIVE_ROLE: SalesExecutiveRole = 'sales_executive';
const COLLECTION_SUPERVISOR_ROLE: CollectionSupervisorRole =
  'collection_supervisor';
const COLLECTION_EXECUTIVE_ROLE: CollectionExecutiveRole =
  'collection_executive';
const OPERATIONS_SUPERVISOR_ROLE: OperationsSupervisorRole =
  'operations_supervisor';
const OPERATIONS_EXECUTIVE_ROLE: OperationsExecutiveRole =
  'operations_executive';
const FINANCE_SUPERVISOR_ROLE: FinanceSupervisorRole = 'finance_supervisor';
const FINANCE_EXECUTIVE_ROLE: FinanceExecutiveRole = 'finance_executive';
const TREASURY_EXECUTIVE_ROLE: TreasuryExecutiveRole = 'treasury_executive';
const CLIENT_ROLE: ClientRole = 'client';
const GUEST_ROLE: GuestRole = 'guest';
const NEW_USER_ROLE: NewUserRole = 'new_user';
const TEST_ROLE: TestRole = 'test';
const BOARD_MEMBER_ROLE: BoardMemberRole = 'board_member';

type RoleName =
  | RiskAnalysisRole
  | SuperAdminRole
  | AdminRole
  | ManagerRole
  | ExecutiveSupervisorRole
  | SalesAssistantRole
  | SalesExecutiveRole
  | CollectionSupervisorRole
  | CollectionExecutiveRole
  | OperationsSupervisorRole
  | OperationsExecutiveRole
  | FinanceSupervisorRole
  | FinanceExecutiveRole
  | TreasuryExecutiveRole
  | ClientRole
  | GuestRole
  | NewUserRole
  | TestRole
  | BoardMemberRole;

type Role = {
  id: string;
  name: string;
  description: string;
  creationDate: string;
  lastModifiedDate: string;
};

export type {
  AdminRole,
  BoardMemberRole,
  ClientRole,
  CollectionExecutiveRole,
  CollectionSupervisorRole,
  ExecutiveSupervisorRole,
  FinanceExecutiveRole,
  FinanceSupervisorRole,
  GuestRole,
  ManagerRole,
  NewUserRole,
  OperationsExecutiveRole,
  OperationsSupervisorRole,
  RiskAnalysisRole,
  Role,
  RoleName,
  SalesAssistantRole,
  SalesExecutiveRole,
  SuperAdminRole,
  TestRole,
  TreasuryExecutiveRole,
};

export {
  ADMIN_ROLE,
  BOARD_MEMBER_ROLE,
  CLIENT_ROLE,
  COLLECTION_EXECUTIVE_ROLE,
  COLLECTION_SUPERVISOR_ROLE,
  EXECUTIVE_SUPERVISOR_ROLE,
  FINANCE_EXECUTIVE_ROLE,
  FINANCE_SUPERVISOR_ROLE,
  GUEST_ROLE,
  MANAGER_ROLE,
  NEW_USER_ROLE,
  OPERATIONS_EXECUTIVE_ROLE,
  OPERATIONS_SUPERVISOR_ROLE,
  RISK_ANALYSIS_ROLE,
  SALES_ASSISTANT_ROLE,
  SALES_EXECUTIVE_ROLE,
  SUPER_ADMIN_ROLE,
  TEST_ROLE,
  TREASURY_EXECUTIVE_ROLE,
};
